App.filter('statusFilter', function () {
    return function (el) {
        el = el || '';

        var dictionary = [];
        
        dictionary['PROCESSING'] = 'w trakcie tworzenia';
        dictionary['READY'] = 'gotowy';

        if (el) {
        	if (dictionary[el]) {
        		return dictionary[el];
        	} else {
        		return el;
        	}
        }

        return el;
    };
})